<template>
  <form
    ref="theform"
    v-validate
    novalidate
    :method="method"
    :content-type="enctype"
    :action="action"
    @submit="trackForm(id, 'ComFormSubmitted')"
  >
    <slot></slot>
  </form>
</template>

<script>
import { setTrackerVersion, trackForm } from '@/helpers/tracker'

export default {
  name: 'SanitasForm',
  props: {
    id: {
      type: String,
      required: true,
    },

    action: {
      type: String,
      default: '',
    },

    enctype: {
      type: String,
      default: 'multipart/form-data',
    },

    method: {
      type: String,
      default: 'POST',
    },

    /**
     * This parameter must be declared here, even if it's not used in that file.
     * It's processed somewhere else in the code.
     */
    redirect: {
      type: String,
      default: '',
    },

    /**
     * This parameter must be declared here, even if it's not used in that file.
     * It's processed somewhere else in the code.
     */
    formstart: {
      type: String,
      default: '',
    },
  },

  mounted() {
    setTrackerVersion()
    trackForm(this.id, 'ComFormStarted')
  },

  methods: {
    trackForm,

    submit() {
      console.log(this.$refs.theform.validate())
    },
  },
}
</script>
